export default function Privacy() {
  return (
    <div className="page" style={{ padding: '20px', lineHeight: '1.6' }}>
      <h1>Politique de Confidentialité</h1>
      <p><em>Dernière mise à jour : 15 mars 2026</em></p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Chez <strong>GamePulse HQ</strong>, la confidentialité de nos visiteurs est une priorité. 
          Ce document détaille les types d'informations que nous collectons et comment nous les utilisons.
        </p>
      </section>

      <section>
        <h2>2. Collecte des Données et Cookies</h2>
        <p>
          Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. 
          Les données collectées incluent notamment votre adresse IP, le type de votre navigateur, 
          votre fournisseur d'accès internet (FAI) et les pages que vous visitez sur notre site.
        </p>
      </section>

      <section>
        <h2>3. Partenaires Publicitaires (Google AdSense)</h2>
        <p>
          Des fournisseurs tiers, y compris Google, utilisent des cookies pour diffuser des annonces 
          basées sur vos visites antérieures sur ce site ou sur d'autres pages Web. 
          L'utilisation des cookies publicitaires par Google lui permet, ainsi qu'à ses partenaires, 
          de vous proposer des publicités basées sur votre navigation.
        </p>
        <p>
          Vous pouvez choisir de désactiver la publicité personnalisée dans les paramètres des annonces de votre compte Google.
        </p>
      </section>

      <section>
        <h2>4. Liens d'Affiliation</h2>
        <p>
          GamePulse HQ participe à des programmes d'affiliation (notamment Instant Gaming). 
          Si vous cliquez sur un lien partenaire et effectuez un achat, nous pouvons recevoir une 
          commission sans aucun frais supplémentaire pour vous. Cela nous aide à maintenir le site en ligne.
        </p>
      </section>

      <section>
        <h2>5. Consentement</h2>
        <p>
          En utilisant notre site, vous consentez par la présente à notre politique de confidentialité 
          et acceptez ses conditions générales.
        </p>
      </section>
    </div>
  );
}